import { ProductsSelectionForm } from '@shared/components/ProductsSelectionForm';
import { usePricingSheetSettings } from '../PricingSheetContext';

export const PricingSheetProductsSettingsForm = () => {
  const { toggleColumn, selectedColIds, addColumn, selectedUserProducts } = usePricingSheetSettings();

  return (
    <ProductsSelectionForm
      selectedColIds={selectedColIds}
      selectedUserProducts={selectedUserProducts}
      addColumn={addColumn}
      toggleColumn={toggleColumn}
    />
  );
};
